var defaultPalette = {
  main: {
    blue: "#14306B",
    brown: "#EAD9C5",
    green: "#284656",
    navy: "#0B1F2F",
    orange: "#ED5B41",
    yellow: "#FFBA22"
  },
  purple: {
    extralight: "#E9E2FE",
    light: "#D3C3FF",
    medium: "#936DFA",
    dark: "#5537A6"
  },
  pink: {
    light: "#FFD7FD",
    medium: "#E26FDD",
    dark: "#9C4899"
  },
  red: {
    extralight: "#FCCCCD",
    light: "#FBAAAD",
    medium: "#F8555B",
    dark: "#A61E24"
  },
  orange: {
    extralight: "#FBDED9",
    light: "#F8BDB3",
    medium: "#F49D8D",
    dark: "#F17C67"
  },
  yellow: {
    extralight: "#FFF1D3",
    light: "#FFE3A7",
    medium: "#FFD67A",
    dark: "#FFC84E"
  },
  blue: {
    extralight: "#D0D6E1",
    light: "#A1ACC4",
    medium: "#7283A6",
    dark: "#435989"
  },
  green: {
    extralight: "#C5FAE8",
    light: "#9AEED2",
    medium: "#34DDA5",
    dark: "#278464"
  },
  black: {
    extralight: "#BBBBBB",
    light: "#707070",
    medium: "#333333",
    dark: "#000000"
  },
  white: {
    extralight: "#FFFFFF",
    light: "#F7F9FA",
    medium: "#EDF1F3",
    dark: "#C8D3D9"
  },
  alert: {
    alert100: "red"
  },
  background: {
    overlay: "rgba(4, 4, 15, 0.7)"
  },
  grey: {
    grey25: "#f6f6f6",
    grey50: "#CCCCCC",
    grey100: "#808080"
  }
};
export { defaultPalette as default };